import IMask  from 'imask';
import $ from "jquery";


$(document).ready(function() {
	let regexpPhone = new RegExp('(7|8)\\s[\(][0-9]{3}[\)]\\s[0-9]{3}[\-][0-9]{2}[\-][0-9]{2}');
	const regexpMail = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);

	let phoneElement = document.querySelectorAll('.jsPhoneMask');

	let phoneMaskSettings = {
		mask: [
			{
				mask: '8 (000) 000-00-00',
				startsWith: '8',
				lazy: true
			},
			{
				mask: '+{7} (000) 000-00-00',
				startsWith: '7',
				lazy: true
			},
			{
				mask: '+{7} (000) 000-00-00',
				startsWith: '',
				lazy: true
			},
			{
				mask: '+{7} (000) 000-00-00',
				startsWith: '9',
				lazy: true
			}
		],
		dispatch: function (appended, dynamicMasked) {
			let number = (dynamicMasked.value + appended).replace(/\D/g, '');

			return dynamicMasked.compiledMasks.find(function (m) {
				return number.indexOf(m.startsWith) === 0;
			}) || this.dynamicMasked.compiledMasks[this.dynamicMasked.compiledMasks.length - 1];
		}
	};

	if (phoneElement.length > 0) {
		for (let i = 0; i < phoneElement.length; i++) {
			let mask = IMask(phoneElement[i], phoneMaskSettings);
		}
	}


	$('body').on('keyup','.jsInput',function(e){
		if ( $(this).hasClass('jsPhoneMask')) {
			if($(this).val() != 0 & regexpPhone.test($(this).val()) == true){
				$(this).closest('.input').removeClass('is-error');
			}
		} else {
			if ($(this).val() != 0 ) {
				$(this).closest('.input').removeClass('is-error');
			}
		}
		if ($(this).val() != 0 ) {
			$(this).closest('.input').addClass('is-changed');
			$(this).closest('.input').removeClass('is-error');
		} else  {
			$(this).closest('.input').removeClass('is-changed');
		}
		if (e.which === 13 || e.keyCode === 13) {
			e.preventDefault()
		}
	});


	$('.jsInput').on('focus', function () {
		$(this).closest('.input').addClass('is-focused')
	});

	$('.jsInput').on('blur', function () {
		$(this).closest('.input').removeClass('is-focused')
	});



	const checkInputs = function (input){

		const parent = input.closest('.input');

		if ( input.hasClass('jsPhoneMask') ){

			if(input.val() != 0 & regexpPhone.test(input.val()) == true){
				parent.removeClass('is-error');
				parent.addClass('is-changed');
			} else{
				parent.addClass('is-error');
				parent.removeClass('is-changed');
			}

		} else if ( input.hasClass('jsInputEmail') ) {
			if(input.val() != 0 & regexpMail.test(input.val()) == true){
				parent.removeClass('is-error');
				parent.addClass('is-changed');
			} else{
				parent.addClass('is-error');
				parent.removeClass('is-changed');
			}
		} else {
			if (input.val().length > 0){
				parent.removeClass('is-error');
				parent.addClass('is-changed');

			} else{
				parent.addClass('is-error');
			}
		}
	};

	const checkFileInputs = function (input){
		const parent = input.closest('.jsFileItem');

		if (input.get(0).files.length === 0) {
			parent.addClass('is-error')
		} else {
			parent.removeClass('is-error')
		}
	};


	const checkCheckboxes = function (input){
		const parent = input.closest('.checkbox');

		if (input.is(':checked')){
			parent.removeClass('is-error')
		} else {
			parent.addClass('is-error')
		}
	};

	const checkSelects = function (select){
		if ( select.val() === '' ) {
			select.closest('.select').addClass('is-error')
		} else {
			select.closest('.select').removeClass('is-error')
		}
	};

	$('.jsFormSubmitButton').on('click', function (e) {
		const form = $(this).closest('.jsForm');
		const reqInputs = form.find('.jsInput[required]');
		const reqFileInputs = form.find('.jsFileItemNative[required]');
		const reqCheckboxes = form.find('.jsCheckBox[required]');
		const reqSelects = form.find('.jsSelect[required]');

		if (reqInputs.length > 0) {
			reqInputs.each(function () {
				checkInputs($(this));
			});
		}

		if (reqFileInputs.length > 0) {
			reqFileInputs.each(function () {
				checkFileInputs($(this));
			});
		}

		if (reqCheckboxes.length > 0) {
			reqCheckboxes.each(function () {
				checkCheckboxes($(this));
			});
		}

		if (reqSelects.length > 0) {
			reqSelects.each(function () {
				checkSelects($(this));
			});
		}




		if (
			// обычные поля
			form.find('.input.is-error').length === 0 && reqInputs.val().length !== 0
			//  поля с файлами
			&& form.find('.jsFileItem.is-error').length === 0
			// чекбоксы
			&& form.find('.checkbox.is-error').length === 0
			// selects
			&& form.find('.select.is-error').length === 0

		) {
			form.find('form').submit();
		} else {
			form.find('.input.is-error').first().find('.jsInput').focus();
			e.preventDefault();
		}

	});

	const formHeight = function (that){
		that.css('height', that.css("height") ) ;
	};

	$('.jsForm').on('submit', function (e) {
		e.preventDefault();

		const parent = $(this).closest('.jsForm');
		const formFront = parent.find('.jsFormFront');
		const formSuccess = parent.find('.jsFormSuccess');


		if ($(window).width() > 767) {
			formHeight($(this).closest('.jsForm'));
		}

		if (parent.height() > 500 ) {
			$('html, body').stop().animate({scrollTop: parent.offset().top - 150 }, 500);
		}

		formFront.fadeOut(350, () => {
			formSuccess.fadeIn(350);
		})

	});
});


